import React from 'react';
import ScrollHideHeader from '../components/layout/scrollHideHeader';
import './error404.css';
import Btn from '../components/common/btn';
import { Link } from 'react-router-dom';
import tornBook from '../assets/imgs/tornbook.svg';
import tornBook2 from '../assets/imgs/tornbook2.svg';
import tornBook2Mob from '../assets/imgs/tornbookMob.svg';
import tornBookMob from '../assets/imgs/tornbook2Mob.svg';


const Error404 = () => {
    return ( 
        <>
        <ScrollHideHeader />
        <main>
            <div className="bgDecor"></div>
            <div className="error">
                <div className="errorDecor">
                    <img className='displayFlex' src={tornBook} alt="Torn book illustration" />
                    <img className='displayNone' src={tornBook2Mob} alt="Torn book illustration" />
                    <h1>404</h1>
                    <img className='displayFlex' src={tornBook2} alt="Torn book illustration" />
                    <img className='displayNone' src={tornBookMob} alt="Torn book illustration" />
                </div>
                <div className="errorCont">
                    <h4>“Not all who wander are lost” <br></br> But this page definitely is.</h4>
                    <Link className='link' to="/">
                        <Btn btnStyle="mainBtn" btnText="BACK TO HOME" />
                    </Link>
                </div>
            </div>
        </main>
        </>
     );
}
 
export default Error404;